<template>
  <v-container >
    <entity-properties-row :label="$t('partOrder.modifyTime')"
                           :property="partOrder.modifyTime | dateTime"/>

    <entity-properties-row :label="$t('partOrder.orderedParts')">
      <part-quantities-view v-model="partOrder.orderedParts"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('partOrder.receivers')">
      <div v-if="partOrder.supplier"
          class="d-flex flex-row flex-wrap">
        <div class="mr-3">{{partOrder.supplier | supplier}}</div>
        <div>{{partOrder.receiverEmail}}</div>
      </div>
      <div v-if="partOrder.ccToSender">
        <span>{{$t('partOrder.ccToSender')}}</span>
      </div>
      <div>
        <plain-unordered-list :items="partOrder.otherSuppliers"/>
      </div>
    </entity-properties-row>

    <entity-properties-row :label="$t('partOrder.title')"
                           :property="partOrder.title"/>

    <entity-properties-row :label="$t('partOrder.message')">
      <preformatted-text-view v-model="partOrder.message"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('partOrder.sendTime')"
                           :property="partOrder.sendTime | dateTime"/>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PlainUnorderedList from '@/components/layouts/PlainUnorderedList';
import PartQuantitiesView from '@/components/layouts/PartQuantitiesView';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';

export default {
  name: 'PartOrderPropertiesView',
  components: { PreformattedTextView, PartQuantitiesView, PlainUnorderedList, EntityPropertiesRow },
  props:{
    partOrder: {
      required:true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
